import { FormControl, InputLabel, Typography } from '@material-ui/core'
import { Rating } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'

const GradeInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  ...props
}) => {
  const translate = useTranslate()
  const [value, setValue] = useState(parseInt(record[source]))
  const handleChange = (value) => {
    setValue(value)
    setPayload(() => {
      return { ...payload, [source]: value }
    })
  }

  return (
    <FormControl fullWidth>
      <Typography
        style={{
          marginTop: '5px',
          color: '#757575',
          fontSize: '16px',
        }}
      >
        {translate(label, { _: label })}
      </Typography>
      <Rating
        name="gradeinput"
        value={value}
        onChange={(event, newValue) => {
          handleChange(newValue)
        }}
      />
    </FormControl>
  )
}
export default GradeInput
